import { Component, EventEmitter, OnInit, Output, OnDestroy, HostListener } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SaleFormService } from '@src/app/features/sales/add-sale/steps/sale-form.service';
import { CompanyResponse } from '@src/app/shared/backend/clients';
import { SessionService } from '@src/app/shared/services/session.service';
import { PermissionService } from '@src/app/shared/services/permission.service';
import { Features } from '@src/app/shared/backend/auth/Feature';
import { WarrantyActivationMethod } from '@src/app/shared/enums/WarrantyActivationMethod.enum';

@Component({
    selector: 'app-add-sale',
    templateUrl: './add-sale.component.html',
    styleUrl: './add-sale.component.scss',
    host: {
        class: 'app-add-sale'
    },
    standalone: false
})
export class AddSaleComponent implements OnInit, OnDestroy {

  @Output() stepSaved = new EventEmitter<void>();

  // ensure cleanup on tab close, reload...
  @HostListener('window:beforeunload')
  unloadHandler() {
    this.saleFormService.clearData();
  }

  saleSteps: any[] = [];
  currentStepIndex: number = 0;
  enableSaleCustomerDetails = true;
  company: CompanyResponse = {
    inventorySubmissionThresholdDays: 0
  };
  isPrevButtonDisabled: boolean = false;

  constructor(
    private translate: TranslateService,
    public session: SessionService,
    public permissionService: PermissionService,
    public saleFormService: SaleFormService
  ) { }

  async ngOnInit() {
    this.company = await this.session.getCompanyData();

    if (!this.session.companySettings) {
      await this.session.getCompanySettings();
    }

    const isCustomersEnabled = await this.permissionService.hasFeaturePermissions(Features.Customers);
    this.enableSaleCustomerDetails = isCustomersEnabled;

    this.initSteps();
  }

  initSteps() {
    const showSaleTypeStep = this.company.hasLimitedEdition || this.company.hasItemsWithoutSerialNumber;

    if (!showSaleTypeStep) {
      this.saleFormService.setStepData('saleType', {
        saleType: WarrantyActivationMethod.SERIAL_NUMBER
      });
    }

    this.updateSteps();
    this.currentStepIndex = 0;
  }

  updateSteps() {
    const showSaleTypeStep = this.company.hasLimitedEdition || this.company.hasItemsWithoutSerialNumber;

    this.saleSteps = [
      { label: this.translate.instant('SALE_CREATE.SELLER_DETAILS'), component: 'seller-details' },
      ...(showSaleTypeStep ? [{ label: this.translate.instant('SALE_CREATE.SALE_TYPE'),
        component: 'sale-type' }] : []),
      { label: this.translate.instant('SALE_CREATE.IDENTIFIER'), component: 'serial-number-validation' },
      ...(this.enableSaleCustomerDetails ? [{ label: this.translate.instant('SALE_CREATE.CUSTOMER_DETAILS'), component: 'customer-details' }] : []),
      ...((this.company.implicitSaleCreation && !this.company.isPrepaired) ? [{ label: this.translate.instant('WARRANTY_ACTIVATION.STEP_WARRANTY_CODE'), component: 'warranty-code' }] : []),
      { label: this.translate.instant('SALE_CREATE.REVIEW_SUBMIT'), component: 'sale-summary' },
    ];
  }

  getStepsCounter() {
    return this.saleSteps.length;
  }

  onPreviousStep() {
    if (this.currentStepIndex > 0) {
      this.currentStepIndex--;
    }
  }

  onNextStep() {
    this.currentStepIndex++;
  }

  disablePrevBtn() {
    this.isPrevButtonDisabled = true;
  }

  ngOnDestroy(): void {
    this.saleFormService.clearData();
  }
}
